import { render, staticRenderFns } from "./RoadPanel.vue?vue&type=template&id=228b5ff8&scoped=true&"
import script from "./RoadPanel.vue?vue&type=script&lang=js&"
export * from "./RoadPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228b5ff8",
  null
  
)

export default component.exports